import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Execution, Model } from '../domain/AIAnalysis';
import type { SessionId } from '../domain/Session';

export const moduleName = 'AUTOMATIC_ANALYSIS';

type PendingAnalysis = { sessionId: string; modelCode: string };

const aiAnalysisSlice = createSlice({
    name: moduleName,
    initialState: {
        executions: [] as Array<Execution>,
        sessionIdsForAnalyses: [] as Array<SessionId>,
        models: [] as Array<Model>,
        pendingAnalyses: [] as Array<PendingAnalysis>,
    },
    reducers: {
        initialized(state, action: PayloadAction<{ models: Array<Model>; executions: Array<Execution> }>) {
            state.executions = action.payload.executions;
            state.models = action.payload.models;
        },
        updatedExecutions(state, action: PayloadAction<Array<Execution>>) {
            state.executions = action.payload;
            state.pendingAnalyses = state.pendingAnalyses.filter(
                ({ sessionId, modelCode }) =>
                    !action.payload.some((e) => e.sessionId === sessionId && e.modelCode === modelCode),
            );
        },
        analysisStarted(state, action: PayloadAction<Execution>) {
            state.executions.push(action.payload);
        },
        sessionIdsForAnalysesChosen(state, action: PayloadAction<Array<SessionId>>) {
            state.sessionIdsForAnalyses = action.payload;
        },
        pendingAnalysisStarted(state, action: PayloadAction<Array<PendingAnalysis>>) {
            state.pendingAnalyses = action.payload;
        },
        pendingAnalysisCleared(state) {
            state.pendingAnalyses = [];
        },
    },
});

export const { initialized, analysisStarted, sessionIdsForAnalysesChosen, updatedExecutions, pendingAnalysisStarted, pendingAnalysisCleared } = aiAnalysisSlice.actions;
export const aiAnalysisReducer = aiAnalysisSlice.reducer;
